import { InputTooltip } from "@components/InputTooltip/InputTooltip";
import { Input } from "antd";

const InputShowTooltip = (props: any) => (
  <InputTooltip title={props.title}>
    <Input
      className="master-data_input-tooltip"
      size="large"
      disabled
      {...props}
      title=""
    />
  </InputTooltip>
);

export { InputShowTooltip };
